import type {FilterOption} from './types'

export const toFilterOptions = (items?: Array<{key?: any; value?: any}> | null): FilterOption[] =>
  (items ?? []).map((item) => ({
    value: String(item.key ?? ''),
    label: item.value ?? '',
  }))

export const formatDateInput = (d: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export const lastThirtyDaysRange = (): {startDate: string; endDate: string} => {
  const now = new Date()
  const start = new Date(now)
  start.setDate(start.getDate() - 30)
  return {startDate: formatDateInput(start), endDate: formatDateInput(now)}
}
